import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://bb74beaa179eb2b74edee465cc5ef974@o4508715132911616.ingest.de.sentry.io/4510300936536144",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
